// extracted by mini-css-extract-plugin
export default {"avatar":"InitialAvatar_avatar__GK3M1","clickable":"InitialAvatar_clickable__9qR49","picture":"InitialAvatar_picture__5w1uU","image":"InitialAvatar_image__e6R8d"};